/**
 * Onthoudt waar iemand heen wilde voordat hij naar /login werd gestuurd, zodat
 * de webapp na het inloggen (wachtwoord of Microsoft-redirect) alsnog daarheen
 * gaat. Nodig voor de knop in een WhatsApp-melding en voor dossierlinks in de
 * overzichtsmail. sessionStorage: per tabblad, overleeft de omweg via
 * Microsoft, verdwijnt bij sluiten.
 */
const SLEUTEL = "naLoginDoel";

/** Alleen eigen paden: begint met één "/", niet de start- of inlogpagina. */
function isBruikbaarDoel(pad: string): boolean {
  return (
    pad.startsWith("/") &&
    !pad.startsWith("//") &&
    pad !== "/" &&
    !pad.startsWith("/login")
  );
}

export function bewaarDoel(pad: string): void {
  if (!isBruikbaarDoel(pad)) return;
  try {
    sessionStorage.setItem(SLEUTEL, pad);
  } catch {
    // Opslag geblokkeerd: dan landt de gebruiker gewoon op de startpagina.
  }
}

/** Geeft het bewaarde doel één keer terug en wist het. */
export function neemDoel(): string | null {
  try {
    const doel = sessionStorage.getItem(SLEUTEL);
    sessionStorage.removeItem(SLEUTEL);
    return doel && isBruikbaarDoel(doel) ? doel : null;
  } catch {
    return null;
  }
}
